import { useEffect, useState } from 'react';

import { productionApi } from 'api/production';

/**
 * Hook to fetch sellable items.
 *
 * @param {string} packGroupID - The pack group ID.
 * @returns {Object} - The sellable items and loading state.
 */
export function useSellableItems(packGroupID) {
    const [loading, setLoading] = useState(true);
    const [sellableItems, setSellableItems] = useState([]);

    useEffect(() => {
        const fetchSellableItems = async () => {
            try {
                if (!packGroupID) return;
                setLoading(true);
                const response = await productionApi.getSellableItems(packGroupID);
                setSellableItems(response.data.sellableItems);
            } catch (error) {
                console.error('Error fetching sellable items:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchSellableItems();
    }, [packGroupID]);

    return { sellableItems, loading };
}
